import { useEffect } from "react";

function Chatbot() {
  useEffect(() => {
    // 1. Prevent duplicate script injection
    if (document.getElementById("VqlnqLbaq3bAbUbtdJomx")) return;

    // 2. Inject Chatbase Script
    const script = document.createElement("script");
    script.innerHTML = `
      (function(){
        if(!window.chatbase || window.chatbase("getState")!=="initialized"){
          window.chatbase=(...arguments)=>{
            if(!window.chatbase.q){window.chatbase.q=[]}
            window.chatbase.q.push(arguments)
          };
          window.chatbase=new Proxy(window.chatbase,{
            get(target,prop){
              if(prop==="q"){return target.q}
              return(...args)=>target(prop,...args)
            }
          })
        }
        const onLoad=function(){
          const script=document.createElement("script");
          script.src="https://www.chatbase.co/embed.min.js";
          script.id="VqlnqLbaq3bAbUbtdJomx";
          script.domain="www.chatbase.co";
          document.body.appendChild(script)
        };
        if(document.readyState==="complete"){onLoad()}
        else{window.addEventListener("load",onLoad)}
      })();
    `;
    document.body.appendChild(script);

    // 3. FORCE THE COLOR CHANGE VIA CSS INJECTION
    // This targets the Chatbase launcher directly and applies your gradient
    const style = document.createElement("style");
    style.innerHTML = `
      #chatbase-bubble-button, 
      #chatbase-bubble-launcher,
      [full-id="chatbase-bubble-launcher"] {
        background: linear-gradient(to right, #2563eb, #4f46e5) !important;
        background-image: linear-gradient(to right, #2563eb, #4f46e5) !important;
      }
      
      /* Target the SVG icon inside if needed */
      #chatbase-bubble-launcher svg {
        color: white !important;
        fill: white !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      const existingScript = document.getElementById("VqlnqLbaq3bAbUbtdJomx");
      if (existingScript) existingScript.remove();
      if (style) style.remove();
    };
  }, []);

  return null; // We return null because the script handles the button UI
}

export default Chatbot;